import { REFRESH_TOKEN_DONE, REFRESH_TOKEN_ERROR, REFRESH_TOKEN, LOGOUT, LOGOUT_DONE, LOGOUT_ERROR, LOGIN, LOGIN_DONE, LOGIN_ERROR } from './actionTypes';
const initialState = {
    status: 'pending',
    data: {}
};
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case REFRESH_TOKEN:
            return state;
        case LOGIN:
        case LOGOUT:
            return initialState;
        case REFRESH_TOKEN_DONE:
            return { status: 'ready', data: action.data };
        case LOGOUT_DONE:
            return Object.assign(Object.assign({}, initialState), { status: 'ready' });
        case LOGIN_DONE:
            // because they didn't want it done in django
            analytics && analytics.track('Login Succeeded');
            return Object.assign(Object.assign({}, state), { status: 'ready', data: Object.assign(Object.assign({}, ('data' in state && state.data)), action.data) });
        case REFRESH_TOKEN_ERROR:
        case LOGIN_ERROR:
        case LOGOUT_ERROR:
            return Object.assign(Object.assign({}, initialState), { status: 'error', errorMessage: action.errorMessage });
        default:
            return state;
    }
};
export default reducer;
//# sourceMappingURL=reducer.js.map